import createFetchSelectors from './createFetchSelectors';

export const {
  getPageSize: getEditionArticlesPageSize,
  getTotalCount: getTotalEditionArticlesCount,
  getPage: getEditionArticlesPage,
  hasMorePages: hasMoreEditionArticles,
  getFilters: getEditionArticleFilters,
  getSliceIds: getEditionTraySliceIds,
  getItems: getEditionArticles,
  isBusy: isEditionTrayBusy,
  getError: getEditionTrayError,
  isReadyOrError: isEditionTrayReadyOrError,
} = createFetchSelectors({
  stateSliceName: 'edition',
  itemTypePlural: 'articles',
  defaultPageSize: 8,
});
